<script>
import { onMount } from "svelte";


	export let story;
	export let deleteStory;
	let seen = false;
	let out = false;

	$ : story, function(){
		console.log(story)
		seen = false
	}()

	onMount(() => {
		seen = false
	})
	
	let mouseOver = () => {
		seen = true
	}
	
	let mouseOut = () => {
		//out = true
		deleteStory(story.id)
	}

	let goTo = () => {
		window.open(story.url, '_blank');
	}

	let truncateStr = (str) => {
		const MAX_CHAR_COUNT = 120
		const endIndex = (str.length < MAX_CHAR_COUNT) ? str.length : MAX_CHAR_COUNT;
		let result = str.substr(0, endIndex)
		if(endIndex===MAX_CHAR_COUNT) {
			result += "..."
		}
		return result
	}
</script>

<style>
	#holder {
		display: inline-flex;
		background-color: white;
		width: 120px;
		height: 180px;
		max-height: 180px;
		padding: 20px;
		cursor: pointer;
		font-size: 14px;
		color: rgb(82, 82, 82) !important;
		position: relative;
		flex-direction: column;
	}

	#title {
		overflow: hidden;
	}

	#info {
		padding-top: 5px;
		font-size: 12px;
		color: grey;
	}
	
	#holder:hover {
		background-color: black !important;
		color: white;
	}
</style>

<div id="holder" style={(seen) ? "background-color: rgb(44, 44, 44);" : ""} on:mouseenter={mouseOver} on:mouseleave={mouseOut} on:click={goTo}>
	<div id="title">
		<b>{truncateStr(story.title)}</b>
	</div>
	<div id="info">
		{story.domain}<br>
		{story.ups} points<br>
		{story.num_comments} comments
	</div>
</div>